import { registrationConfig as currentRegistrationPhase } from '@fs/zion-rootstech'

const registrationConfig = {
  pricing: {
    EARLY: 'early',
    LAST_CHANCE: 'lastChance',
    STANDARD: 'standard',
    DOOR: 'door',
  },
  defaultPromoVideos: currentRegistrationPhase.promoVideos,
  discoveryPromoVideos: {
    de: 'XdIxhuY_zlg',
    en: 'CKikmJYJFvY',
    es: 'tCxu5nMw1sU',
    fr: 'p_hqf6USeWk',
    it: '7mA31fxTmAg',
    ja: 'nGqPJGTATV4',
    ko: 'UT4m5iFnBgE',
    mn: 'zzGzbHoIFhk', // english for now since there is no mn translation
    pt: 'IICNZSgN528',
    ru: 'csiutIuVFz8',
    zh: 'T03P9Z3aJyw',
    'zh-hans': 'ZGrheJKq3w8',
  },
  attendeePricing: {
    early: {
      threeDay: currentRegistrationPhase.pricing.earlyBird.threeDay,
      oneDay: currentRegistrationPhase.pricing.earlyBird.oneDay,
    },
    standard: {
      threeDay: currentRegistrationPhase.pricing.standard.threeDay,
      oneDay: currentRegistrationPhase.pricing.standard.oneDay,
    },
    lastChance: {
      threeDay: currentRegistrationPhase.pricing.standard.threeDay,
      oneDay: currentRegistrationPhase.pricing.standard.oneDay,
    },
    door: {
      threeDay: currentRegistrationPhase.pricing.door.threeDay,
      oneDay: currentRegistrationPhase.pricing.door.oneDay,
    },
  },
  eventCodes: currentRegistrationPhase.eventCodes,
  pricingDetails: {
    early: {
      overline: {
        threeDay: { key: 'in-person.pricing.early.3day.overline', default: 'Early Bird Price – Save $30' },
        oneDay: { key: 'in-person.pricing.early.1day.overline', default: 'Early Bird Price – Save $10' },
      },
      subheading: {
        threeDay: { key: 'in-person.pricing.early.3day.subheading', default: '<S>$129</S> Standard Price' },
        oneDay: { key: 'in-person.pricing.early.1day.subheading', default: '<S>$79</S> Standard Price' },
      },
    },
    lastChance: {
      overline: {
        threeDay: { key: 'in-person.pricing.lastChance.overline', default: 'Buy now – Save $20' },
        oneDay: { key: 'in-person.pricing.lastChance.overline', default: 'Buy now – Save $20' },
      },
      subheading: {
        threeDay: { key: 'in-person.pricing.lastChance.3day.subheading', default: '$149 at the door' },
        oneDay: { key: 'in-person.pricing.lastChance.1day.subheading', default: '$99 at the door' },
      },
    },
    standard: {
      overline: { threeDay: null, oneDay: null },
      subheading: { threeDay: null, oneDay: null },
    },
    door: {
      overline: { threeDay: null, oneDay: null },
      subheading: { threeDay: null, oneDay: null },
    },
  },
}

export default registrationConfig
